import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  type: 'Performance Overview Sub Branch',
  currentYear: '',
  currentQuarter: '',
  selectedYear: '',
  selectedQuarter: '',
  compareSelectedYear: '',
  compareSelectedQuarter: '',
  performanceOverviewSubBranchRange: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null,
  },
  performanceOverviewSubBranchCompareRange: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null,
  },
};

const performanceOverviewSubBranch = createSlice({
  name: 'performanceOverviewSubBranch',
  initialState,
  reducers: {
    setCurrentQuarter: (state, action) => {
      return { ...state, currentQuarter: action.payload };
    },
    setCurrentYear: (state, action) => {
      return { ...state, currentYear: action.payload };
    },
    setSelectedQuarter: (state, action) => {
      return { ...state, selectedQuarter: action.payload };
    },
    setSelectedYear: (state, action) => {
      return { ...state, selectedYear: action.payload };
    },
    setCompareSelectedYear: (state, action) => {
      return { ...state, compareSelectedYear: action.payload };
    },
    setCompareSelectedQuarter: (state, action) => {
      return { ...state, compareSelectedQuarter: action.payload };
    },
    setPerformanceOverviewSubBranchRange: (state, action) => {
      return { ...state, performanceOverviewSubBranchRange: action.payload };
    },
    setPerformanceOverviewSubBranchCompareRange: (state, action) => {
      return { ...state, performanceOverviewSubBranchCompareRange: action.payload };
    },
  },
});

export const performanceOverviewSubBranchActions = performanceOverviewSubBranch.actions;

export default performanceOverviewSubBranch.reducer;
